import { render, staticRenderFns } from "./gamblers.vue?vue&type=template&id=a5eabe14&scoped=true&"
import script from "./gamblers.vue?vue&type=script&lang=js&"
export * from "./gamblers.vue?vue&type=script&lang=js&"
import style0 from "./gamblers.vue?vue&type=style&index=0&id=a5eabe14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5eabe14",
  null
  
)

export default component.exports